import { connect } from "react-redux";
import {
  scopeItem,
  scopeItems,
  tasks,
  tasksLoading,
  taskLoading,
  taskPagination,
  getError,
  resourceShifts,
  resourcesMonitor,
  overviewLoader,
} from "../../store/selectors/scope.selector";
import {
  getScopeDetails,
  getScope,
  getTasks,
  createTask,
  updateTask,
  deleteTask,
  resourcesShiftsRequest,
  resourcesMonitorRequest,
  deleteScopeRequest,
  updateScopeRequest,
  duplicateTaskRequest,
} from "../../store/actions/scope.actions";

import ScopeOverview from "./ScopeOverview";
const mapDispatchToProps = {
  getScopeDetails,
  getScopeItemsRequest: getScope,
  getTasksRequest: getTasks,
  createTaskRequest: createTask,
  updateTaskRequest: updateTask,
  deleteTaskRequest: deleteTask,
  resourcesShiftsRequest,
  resourcesMonitorRequest,
  deleteScopeRequest,
  updateScopeRequest,
  duplicateTaskRequest,
};
const mapStateToProps = (state) => {
  const allResourceShifts = resourceShifts(state);
  const scopeDetails = scopeItem(state);
  const allTasks = tasks(state);
  const pageLoading = tasksLoading(state);
  const loading = taskLoading(state);
  const pagination = taskPagination(state);
  const error = getError(state);
  const allScopeItems = scopeItems(state);
  const allResourcesMonitor = resourcesMonitor(state);
  const overviewLoading = overviewLoader(state);

  return {
    allResourceShifts,
    scopeDetails,
    allTasks,
    allScopeItems,
    overviewLoading,
    loading,
    pageLoading,
    pagination,
    error,
    allResourcesMonitor,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScopeOverview);
